module.exports = __webpack_public_path__ + "img/homebg04.28e4d39e.svg";